module.exports = __webpack_public_path__ + "static/zdjęcia12-aadeb616dce4f1bdc7a29ec046ca6b84.svg";